import React from 'react'
import { useRouter } from '@morningtrain/react-navigation'

export default function Logo (props) {
  const router = useRouter()

  const logo_url = router.url('img/jfm-logo.png')

  return (
    <img src={logo_url} className={props.className} />
  )
}
